export const content = [
    {
        id: 1,
        text: '<p>Knox Guard provides security features which enable us to protect your devices and assets from fraud, theft and data loss.</p>'
    },
    {
        id: 2,
        text: '<p>These security measures reduce costs and alleviate complexity, allowing us to provide the lowest possible subscription prices for you.</p>'
    },
    {
        id: 3,
        text: '<p>When will we use Knox Guard:</p>' +
        '<ol>' +
        '<li>When payment is not paid on time </li>' +
        '<li>When your SIM card has been removed</li>' +
        '<li>When your device hasn’t been online for an extended period of time</li>' +
        '<li>f your device has been lost or stolen</li>' +
        '</ol>' +
        '<p>The device and app functionality will automatically be restricted to only allow for emergency calls and calls to Cinch’s customer service hotline.</p>'
    }
];
